var map = {
	"../browser/browser.module": [
		"./src/app/pages/browser/browser.module.ts",
		"browser-browser-module"
	],
	"../exchange/home/home.module": [
		"./src/app/pages/exchange/home/home.module.ts",
		"exchange-home-home-module"
	],
	"../home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"home-home-module"
	],
	"../settings/home/home.module": [
		"./src/app/pages/settings/home/home.module.ts",
		"settings-home-home-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./pages/admin/accounts/accounts.module": [
		"./src/app/pages/admin/accounts/accounts.module.ts",
		"pages-admin-accounts-accounts-module"
	],
	"./pages/admin/editlimit/editlimit.module": [
		"./src/app/pages/admin/editlimit/editlimit.module.ts",
		"pages-admin-editlimit-editlimit-module"
	],
	"./pages/admin/home/home.module": [
		"./src/app/pages/admin/home/home.module.ts",
		"pages-admin-home-home-module"
	],
	"./pages/admin/users/users.module": [
		"./src/app/pages/admin/users/users.module.ts",
		"pages-admin-users-users-module"
	],
	"./pages/admin/viewwallet/viewwallet.module": [
		"./src/app/pages/admin/viewwallet/viewwallet.module.ts",
		"pages-admin-viewwallet-viewwallet-module"
	],
	"./pages/admin/wallets/wallets.module": [
		"./src/app/pages/admin/wallets/wallets.module.ts",
		"pages-admin-wallets-wallets-module"
	],
	"./pages/admin/withdraw/withdraw.module": [
		"./src/app/pages/admin/withdraw/withdraw.module.ts",
		"pages-admin-withdraw-withdraw-module"
	],
	"./pages/assets/assets.module": [
		"./src/app/pages/assets/assets.module.ts",
		"pages-assets-assets-module"
	],
	"./pages/exchange/home/home.module": [
		"./src/app/pages/exchange/home/home.module.ts",
		"exchange-home-home-module"
	],
	"./pages/news/view/view.module": [
		"./src/app/pages/news/view/view.module.ts",
		"pages-news-view-view-module"
	],
	"./pages/settings/about/about.module": [
		"./src/app/pages/settings/about/about.module.ts",
		"pages-settings-about-about-module"
	],
	"./pages/settings/admin/admin.module": [
		"./src/app/pages/settings/admin/admin.module.ts",
		"pages-settings-admin-admin-module"
	],
	"./pages/settings/changepassword/changepassword.module": [
		"./src/app/pages/settings/changepassword/changepassword.module.ts",
		"pages-settings-changepassword-changepassword-module"
	],
	"./pages/settings/editprofile/editprofile.module": [
		"./src/app/pages/settings/editprofile/editprofile.module.ts",
		"pages-settings-editprofile-editprofile-module"
	],
	"./pages/settings/impsbalance/impsbalance.module": [
		"./src/app/pages/settings/impsbalance/impsbalance.module.ts",
		"pages-settings-impsbalance-impsbalance-module"
	],
	"./pages/settings/impslimit/impslimit.module": [
		"./src/app/pages/settings/impslimit/impslimit.module.ts",
		"pages-settings-impslimit-impslimit-module"
	],
	"./pages/settings/prime/enter/enter.module": [
		"./src/app/pages/settings/prime/enter/enter.module.ts",
		"pages-settings-prime-enter-enter-module"
	],
	"./pages/settings/prime/v1/affiliate/affiliate.module": [
		"./src/app/pages/settings/prime/v1/affiliate/affiliate.module.ts",
		"pages-settings-prime-v1-affiliate-affiliate-module"
	],
	"./pages/settings/prime/v1/home/home.module": [
		"./src/app/pages/settings/prime/v1/home/home.module.ts",
		"pages-settings-prime-v1-home-home-module"
	],
	"./pages/settings/prime/v1/kyc/kyc.module": [
		"./src/app/pages/settings/prime/v1/kyc/kyc.module.ts",
		"pages-settings-prime-v1-kyc-kyc-module"
	],
	"./pages/settings/prime/v1/receive/receive.module": [
		"./src/app/pages/settings/prime/v1/receive/receive.module.ts",
		"common",
		"pages-settings-prime-v1-receive-receive-module"
	],
	"./pages/settings/prime/v1/send/send.module": [
		"./src/app/pages/settings/prime/v1/send/send.module.ts",
		"common",
		"pages-settings-prime-v1-send-send-module"
	],
	"./pages/settings/prime/v1/stakings/stakings.module": [
		"./src/app/pages/settings/prime/v1/stakings/stakings.module.ts",
		"pages-settings-prime-v1-stakings-stakings-module"
	],
	"./pages/settings/prime/v1/wallet/wallet.module": [
		"./src/app/pages/settings/prime/v1/wallet/wallet.module.ts",
		"common",
		"pages-settings-prime-v1-wallet-wallet-module"
	],
	"./pages/settings/prime/v1/withdraw/withdraw.module": [
		"./src/app/pages/settings/prime/v1/withdraw/withdraw.module.ts",
		"pages-settings-prime-v1-withdraw-withdraw-module"
	],
	"./pages/settings/prime/v2/addstaking/addstaking.module": [
		"./src/app/pages/settings/prime/v2/addstaking/addstaking.module.ts",
		"pages-settings-prime-v2-addstaking-addstaking-module"
	],
	"./pages/settings/prime/v2/addwithdrawal/addwithdrawal.module": [
		"./src/app/pages/settings/prime/v2/addwithdrawal/addwithdrawal.module.ts",
		"pages-settings-prime-v2-addwithdrawal-addwithdrawal-module"
	],
	"./pages/settings/prime/v2/balance/balance.module": [
		"./src/app/pages/settings/prime/v2/balance/balance.module.ts",
		"pages-settings-prime-v2-balance-balance-module"
	],
	"./pages/settings/prime/v2/home/home.module": [
		"./src/app/pages/settings/prime/v2/home/home.module.ts",
		"common",
		"pages-settings-prime-v2-home-home-module"
	],
	"./pages/settings/prime/v2/income/income.module": [
		"./src/app/pages/settings/prime/v2/income/income.module.ts",
		"pages-settings-prime-v2-income-income-module"
	],
	"./pages/settings/prime/v2/stakings/stakings.module": [
		"./src/app/pages/settings/prime/v2/stakings/stakings.module.ts",
		"pages-settings-prime-v2-stakings-stakings-module"
	],
	"./pages/settings/prime/v2/team/team.module": [
		"./src/app/pages/settings/prime/v2/team/team.module.ts",
		"pages-settings-prime-v2-team-team-module"
	],
	"./pages/settings/prime/v2/withdrawals/withdrawals.module": [
		"./src/app/pages/settings/prime/v2/withdrawals/withdrawals.module.ts",
		"pages-settings-prime-v2-withdrawals-withdrawals-module"
	],
	"./pages/settings/profile/profile.module": [
		"./src/app/pages/settings/profile/profile.module.ts",
		"pages-settings-profile-profile-module"
	],
	"./pages/settings/security/security.module": [
		"./src/app/pages/settings/security/security.module.ts",
		"pages-settings-security-security-module"
	],
	"./pages/settings/share/share.module": [
		"./src/app/pages/settings/share/share.module.ts",
		"common",
		"pages-settings-share-share-module"
	],
	"./pages/settings/twofactor/twofactor.module": [
		"./src/app/pages/settings/twofactor/twofactor.module.ts",
		"common",
		"pages-settings-twofactor-twofactor-module"
	],
	"./pages/tabs/tabs.module": [
		"./src/app/pages/tabs/tabs.module.ts",
		"pages-tabs-tabs-module"
	],
	"./pages/verify/verify.module": [
		"./src/app/pages/verify/verify.module.ts",
		"pages-verify-verify-module"
	],
	"./pages/wallet/create/create.module": [
		"./src/app/pages/wallet/create/create.module.ts",
		"pages-wallet-create-create-module"
	],
	"./pages/wallet/home/home.module": [
		"./src/app/pages/wallet/home/home.module.ts",
		"common",
		"pages-wallet-home-home-module"
	],
	"./pages/wallet/receive/receive.module": [
		"./src/app/pages/wallet/receive/receive.module.ts",
		"common",
		"pages-wallet-receive-receive-module"
	],
	"./pages/wallet/select/select.module": [
		"./src/app/pages/wallet/select/select.module.ts",
		"pages-wallet-select-select-module"
	],
	"./pages/wallet/send/send.module": [
		"./src/app/pages/wallet/send/send.module.ts",
		"common",
		"pages-wallet-send-send-module"
	],
	"./pages/walletoptions/rename/rename.module": [
		"./src/app/pages/walletoptions/rename/rename.module.ts",
		"pages-walletoptions-rename-rename-module"
	],
	"./register/register.module": [
		"./src/app/register/register.module.ts",
		"register-register-module"
	],
	"./reset/reset.module": [
		"./src/app/reset/reset.module.ts",
		"reset-reset-module"
	],
	"./terms/terms.module": [
		"./src/app/terms/terms.module.ts",
		"terms-terms-module"
	],
	"./welcome/welcome.module": [
		"./src/app/welcome/welcome.module.ts",
		"welcome-welcome-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;